/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterOnDailyRate
 */
export interface SourcingSearchFilterOnDailyRate {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchFilterOnDailyRate
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterOnDailyRate
     */
    minDailyRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterOnDailyRate
     */
    maxDailyRate?: number;
}

/**
 * Check if a given object implements the SourcingSearchFilterOnDailyRate interface.
 */
export function instanceOfSourcingSearchFilterOnDailyRate(value: object): value is SourcingSearchFilterOnDailyRate {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterOnDailyRateFromJSON(json: any): SourcingSearchFilterOnDailyRate {
    return SourcingSearchFilterOnDailyRateFromJSONTyped(json, false);
}

export function SourcingSearchFilterOnDailyRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterOnDailyRate {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'minDailyRate': json['minDailyRate'] == null ? undefined : json['minDailyRate'],
        'maxDailyRate': json['maxDailyRate'] == null ? undefined : json['maxDailyRate'],
    };
}

export function SourcingSearchFilterOnDailyRateToJSON(value?: SourcingSearchFilterOnDailyRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currencyCode': value['currencyCode'],
        'minDailyRate': value['minDailyRate'],
        'maxDailyRate': value['maxDailyRate'],
    };
}

